import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "../../Common/Layout";

export default function DeleteData() {
  const [search, setSearch] = useState("");

  const [clients, setClients] = useState([]);

  const token = sessionStorage.getItem("token");

  /* ===============================
        FETCH CLIENTS
  =============================== */
  const fetchClients = async () => {
    try {
      const res = await axios.get(
        "https://irc.zentelex.com/api/delete/master-client",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setClients(res.data.data || []);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Unable to load clients",
      });
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  /* ===============================
        DELETE CLIENT
  =============================== */





const deleteClient = async (client) => {
  const result = await Swal.fire({
    title: "⚠ Confirm Client Deletion",
    width: 750,
    icon: "warning",
    html: `
      <div style="text-align:left;font-size:14px;line-height:1.7">

        <h5 style="color:#0d6efd">📄 Basic Information</h5>
        <p><b>CRD No:</b> ${client.crdNo}</p>
        <p><b>Company Name:</b> ${client.company_name}</p>
        <p><b>Contact Number:</b> ${client.contact_number}</p>
        <p><b>Address:</b> ${client.address}</p>

        <hr/>

        <h5 style="color:#0d6efd">📦 Cargo Details</h5>
        <p><b>Product:</b> ${client.product}</p>
        <p><b>Cargo Type:</b> ${client.cargo_type}</p>
        <p><b>Variety:</b> ${client.variety}</p>
        <p><b>Quality Grade:</b> ${client.quality_grade}</p>

        <hr/>

        <h5 style="color:#0d6efd">🏭 Warehouse Details</h5>
        <p><b>Warehouse:</b> ${client.warehouse}</p>
        <p><b>Warehouse Address:</b> ${client.warehouse_address}</p>
        <p><b>BL / Vessel No:</b> ${client.bl_vessel_no}</p>

        <hr/>

        <h5 style="color:#0d6efd">👷 Labour Details</h5>
        <p><b>Labour Contractor:</b> ${client.labourContractor}</p>

        <hr/>

        <h5 style="color:#0d6efd">📝 Other Details</h5>
        <p><b>Remarks:</b> ${client.remarks}</p>
        <p><b>Order Date:</b> ${client.order_date}</p>


        <hr/>
        <p style="color:red;font-weight:bold">
          This action cannot be undone!
        </p>

      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "🗑 Yes Delete",
    confirmButtonColor: "#dc3545",
    cancelButtonColor: "#6c757d",
  });

  if (!result.isConfirmed) return;

  try {
    Swal.fire({
      title: "Deleting...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    await axios.delete(
      `https://irc.zentelex.com/api/delete/master-client/${client.id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Deleted Successfully",
      timer: 1500,
      showConfirmButton: false,
    });

    fetchClients();
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Delete Failed",
      text: "Something went wrong",
    });
  }
};






  const filteredClients = clients.filter((client) => {
    const text = search.toLowerCase();

    return (
      client.crdNo?.toLowerCase().includes(text) ||
      client.company_name?.toLowerCase().includes(text) ||
      client.contact_number?.toLowerCase().includes(text) ||
      client.product?.toLowerCase().includes(text) ||
      client.status?.toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <h3 className="fw-bold mb-4">🗑 Master Client Delete Panel</h3>

      <div className="mb-3">
        <input
          type="text"
          className="form-control border-primary"
          placeholder="🔍 Search CRD No / Company / Contact / Product / Status..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="table-responsive shadow-sm">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>CRD No</th>
              <th>Company</th>
              <th>Contact</th>
              <th>Product</th>
              <th>Status</th>
              <th width="120">Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredClients.length > 0 ? (
              filteredClients.map((client) => (
                <tr key={client.id}>
                  <td>{client.crdNo}</td>
                  <td>{client.company_name}</td>
                  <td>{client.contact_number}</td>
                  <td>{client.product}</td>
                  <td>
                    <span
                      className={`badge ${
                        client.status === "APPROVED"
                          ? "bg-success"
                          : "bg-warning text-dark"
                      }`}
                    >
                      {client.status}
                    </span>
                  </td>

                  <td>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => deleteClient(client)}
                    >
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No Clients Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
